// 1. React and fabric. 
// 2. Store and Types. 

export default interface IOrdersLineItemsEditorState
{
	bEnableTaxLineItems?  : boolean;
	bEnableTaxShipping?   : boolean;
	bShowTax?             : boolean;
	bEnableSalesTax?      : boolean;
	bDisableExchangeRate? : boolean;
	oNumberFormat?        : any;

	CURRENCY_ID?          : string;
	// 11/12/2022 Paul.  We can't dynamically convert to a number as it will prevent editing. 
	EXCHANGE_RATE?        : string;
	TAXRATE_ID?           : string;
	SHIPPER_ID?           : string;

	CURRENCY_ID_LIST?     : any[];
	TAXRATE_ID_LIST?      : any[];
	SHIPPER_ID_LIST?      : any[];

	SUBTOTAL?             : number;
	DISCOUNT?             : number;
	// 11/12/2022 Paul.  We can't dynamically convert to a number as it will prevent editing. 
	SHIPPING?             : string;
	TAX?                  : number;
	TOTAL?                : number;
}

